import { Component, inject } from '@angular/core';
import { LightVehicleService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LightVehicleCreateDto,
  LightVehicleDto,
  LightVehicleExcelDownloadDto,
  LightVehicleUpdateDto,
} from '../proxy/general/dtos/light-vehicle';
import { LIGHTVEHICLE_CONFIG, LIGHTVEHICLE_FIELDS } from './light-vehicle.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-light-vehicle',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LightVehicleService, ConfirmationService],
  templateUrl: './light-vehicle.html',
  styleUrl: './light-vehicle.scss',
})
export class LightVehicle extends BaseHierarchicalCrudComponent<
  LightVehicleDto,
  LightVehicleCreateDto,
  LightVehicleUpdateDto,
  LightVehicleExcelDownloadDto
> {
  service = inject(LightVehicleService);
  config = LIGHTVEHICLE_CONFIG;
  fields = LIGHTVEHICLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: LightVehicleDto): LightVehicleUpdateDto {
    return {
      vehicleId: data.vehicleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LightVehicle';
  }
}
